<template>
  <div>
    <el-group-title title="周转材租赁合同">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称：" prop="projectName">
                <el-input
                  v-model="form.projectName"
                  class="ccui-form-longInput"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="50"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="是否抵扣：" prop="isDeduction">
                <el-select
                  v-model="form.isDeduction"
                  class="ccui-form-longInput"
                  placeholder="请选择是否抵扣"
                >
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "pcConcLease",
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        id: "",
        projectName: "",
        isDeduction: "",
        tContactId: ""
      },
      rules: {}
    };
  },
  watch: {
    dataInfo() {
      this.form = this.dataInfo;
    }
  }
};
</script>
